<template>
  <!-- NOTIFICATIONS -->

  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer" ref="checkit_msg" >
   
    <span class="iconify" data-icon="feather:user-plus" data-inline="false" :badge="newMessages"></span>
    <feather-icon  icon="MessageSquareIcon" class="cursor-pointer mt-1 sm:mr-6 mr-2" :badge="newMessages" />

    <vs-dropdown-menu class="notification-dropdown dropdown-custom vx-navbar-dropdown">

      <div  class="notification-top text-center p-2 bg-primary text-white">
        <h5 class="text-white p-2 mb-4">{{newMessages}} New Messages</h5>
        <p class="opacity-75">App Notifications</p>
      </div>
      <router-link :to="{ path: '/alerts'}" class="text-inherit underline" > 
      <div class="
        checkout-footer
        fixed
        bottom-0
        rounded-b-lg
        text-primary
        w-full
        p-2
        font-semibold
        text-center
        border
        border-b-2
        border-l-0
        border-r-0
        border-solid
        d-theme-border-grey-light
        cursor-pointer"
        @click="closeit">
        <span ><span v-if="newMessages" class="bg-primary text-white" 
        style="position: absolute;
        top: 2px;
        left: 280px;
        padding: 5px 9px;
        border-radius: 50%;
        ">{{newMessages}}</span>View New Messages</span>
      </div>
      </router-link>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {GET_UNSEEN_MESSAGE} from '@/graphql'


export default {
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {
      newMessages:0,
      adminRole:'',
      meID:'',
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  computed: {
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    closeit () {
      this.newMessages = 0
      this.$refs['checkit_msg'].$el.click()
    },
    elapsedTime (startTime) {
      const x        = new Date(startTime)
      const now      = new Date()
      let timeDiff = now - x
      timeDiff    /= 1000

      const seconds = Math.round(timeDiff)
      timeDiff    = Math.floor(timeDiff / 60)

      const minutes = Math.round(timeDiff % 60)
      timeDiff    = Math.floor(timeDiff / 60)

      const hours   = Math.round(timeDiff % 24)
      timeDiff    = Math.floor(timeDiff / 24)

      const days    = Math.round(timeDiff % 365)
      timeDiff    = Math.floor(timeDiff / 365)

      const years   = timeDiff

      if (years > 0) {
        return `${years + (years > 1 ? ' Years ' : ' Year ')}ago`
      } else if (days > 0) {
        return `${days + (days > 1 ? ' Days ' : ' Day ')}ago`
      } else if (hours > 0) {
        return `${hours + (hours > 1 ? ' Hrs ' : ' Hour ')}ago`
      } else if (minutes > 0) {
        return `${minutes + (minutes > 1 ? ' Mins ' : ' Min ')}ago`
      } else if (seconds > 0) {
        return seconds + (seconds > 1 ? ' sec ago' : 'just now')
      }

      return 'Just Now'
    },
    // Method for creating dummy notification time
    randomDate ({ hr, min, sec }) {
      const date = new Date()

      if (hr) date.setHours(date.getHours() - hr)
      if (min) date.setMinutes(date.getMinutes() - min)
      if (sec) date.setSeconds(date.getSeconds() - sec)

      return date
    }
  },
  mounted () {
    // Listen for the 'NewMessageNotification' event in the 'synchronized' private channel
    this.$echo.channel('synchronized').listen('NewMessageNotification', (payload) => {
      if (payload) {
        if (this.meID !== payload.message.user_id) {
          console.log(this.meID, payload.message.user_id)
          this.newMessages++
        }
           
      }
    })

  },
  created () {
      let userId= localStorage.getItem('userId');
      let userRole = JSON.parse(localStorage.getItem('userRoles'))
      userRole = userRole[0].name

        this.meID = userId
        this.adminRole = userRole
      
        this.$apollo
          .mutate({
            mutation: GET_UNSEEN_MESSAGE,
            variables: {
              user_id: userId
            }
          }) 
          .then(response => {
            this.newMessages = response.data.getUnseenChat.counter
          }).catch((error) => {
            console.log(error)
          })
  }
}

</script>
<style lang="scss">
.w3-badge{border-radius:50%}
.w3-hover-red:hover{color:#fff!important;background-color:#f44336!important}
.w3-hover-green:hover{color:#fff!important;background-color:#4CAF50!important}
</style>

